import { render, staticRenderFns } from "./Arts.vue?vue&type=template&id=86f888e2&scoped=true"
import script from "./Arts.vue?vue&type=script&lang=js"
export * from "./Arts.vue?vue&type=script&lang=js"
import style0 from "./Arts.vue?vue&type=style&index=0&id=86f888e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f888e2",
  null
  
)

export default component.exports